import { useEffect } from "react";
import dynamic from "next/dynamic";

import CareersPage from "@/containers/CareersPage";
import { renderMetaData } from "@/utils";
//Redux
import { wrapper } from "@/redux/Store";
import * as dashboardActions from "@/redux/DashboardReducer";
import { careerDetailsApi } from "@/redux/CareersPageReducer";
import { getHealthProgramPage } from "@/redux/HealthProgramReducer";

import { useAppDispatch } from "@/hooks";

const Careers = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getHealthProgramPage({ slug: "general/career" }));
    dispatch(careerDetailsApi({}));
  }, [dispatch]);

  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/careers",
    title: "Careers at Shyft",
    description: "Find different roles available at Shyft health",
    thumbnail: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
    h1Text: "Careers at Shyft",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main>
        <CareersPage />
      </main>
    </>
  );
};

export default Careers;

// export const getServerSideProps = wrapper.getServerSideProps(
//   (store) => async () => {
//     await store.dispatch(
//       dashboardActions.getRibbonData({ pathname: "careers" })
//     );

//     await store.dispatch(getHealthProgramPage({ slug: "general/career" }));

//     await store.dispatch(careerDetailsApi({}));

//     // if (!res?.payload) {
//     //   return {
//     //     notFound: true,
//     //   };
//     // }
//   }
// );
